export default "__VITE_ASSET__UIFesTxl__"